export default __webpack_public_path__ + "static/media/ca_full_no_background.b70c32e4.png";